import { render, staticRenderFns } from "./EnvironmentResourceCard.vue?vue&type=template&id=8ed441c6&"
import script from "./EnvironmentResourceCard.vue?vue&type=script&lang=ts&"
export * from "./EnvironmentResourceCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports